<template>
<!--
// 需要解决v-model双向绑定的问题,因为修改父的是数据是不行
-->
  <vs-sidebar
    :click-not-close="clickNotClose"
    position-right
    v-model="selfDialogShow"
    class="items-no-padding sliderBar-dialog-shell sidebar-dialog"
  >
    <div
      class="sidebar-content h-full"
    >
      <div
        class="customizer-header flex items-center justify-between px-6 sliderbar-header"
      >
        <div>
          {{dialogTitle}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar
        class="scroll-area--customizer pt-4 pb-6"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="content px-6">
          <slot></slot>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar"
      slot="footer"
    >
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >取消</el-button>
      <vs-button
        v-loading="loading"
        @click="submitHandle"
        color="primary"
      >确认</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { setBodyHidden,setBodyNormal } from "@/utils/common";
export default {
  name: "sliderBarDialogShell",
  components: {
    VuePerfectScrollbar,
  },
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogShow:{
      type: Boolean,
      default: false,
    },
    clickNotClose: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    let _this = this;
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      selfDialogShow: _this.dialogShow,
      loading: false,
    }
  },
  computed: {

  },
  watch: {
    dialogShow(val){
      this.selfDialogShow = val;
    },
    selfDialogShow(val){
      if(!val){
        this.close();
      }
      if(val){
        setBodyHidden();
      }else {
        setBodyNormal();
      }
    },
  },
  methods: {
    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.close();
    },
    submitHandle(){
      this.$emit('submit')
    },
    cancelHandle(){
      this.close();
    }
  },
}
</script>
<style lang="scss">
.sliderBar-dialog-shell {
  .content {
    padding-top: 30px;
    overflow-y: auto;
  }
}

</style>
<style lang="scss">
// sidebar弹窗的统一弹窗样式,层级
.sliderBar-dialog-shell {
  .shuoming-icon {
    margin-left: 5px;
  }
  .vs-sidebar--items {

  }
  .scroll-area--customizer {
    height: calc(100% - 5rem);
  }
  .vs-sidebar {
    z-index: 1002;
    position: fixed;

    /*.sidebar-content {
      .content {
        height: calc(100vh - 46px - 83px);
      }
    }*/
  }
  // sidebar弹框的遮罩层
  .vs-sidebar--background {
    z-index: 1001!important;
  }
  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
